export default __webpack_public_path__ + "static/media/s3.18891c8d.png";